import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, CheckCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function GraphicDesignSection() {
  return <section className="py-24 bg-gray-50 border-t border-gray-100" data-id="element-174">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-176">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0" data-id="element-177">
            {/* Content */}
            <div className="p-12 flex flex-col justify-center" data-id="element-178">
              <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-179">
                Design Support
              </span>

              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-yellow-50 text-wh-yellow font-bold text-sm mb-6 w-fit" data-id="element-180">
                <Sparkles className="w-4 h-4" data-id="element-181" />
                Graphic Design Included
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-182">
                Don't Have Artwork?{' '}
                <span className="text-wh-pink" data-id="element-183">We Can Help.</span>
              </h2>

              <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-184">
                Our experienced graphic design team can create custom artwork,
                convert your ideas to print-ready files, or prepare your
                existing designs for production.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-185">
                <li className="flex items-start gap-3" data-id="element-186">
                  <CheckCircle className="w-6 h-6 text-wh-teal flex-shrink-0 mt-0.5" data-id="element-187" />
                  <span className="text-gray-700" data-id="element-188">
                    Custom logo design and artwork creation
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-189">
                  <CheckCircle className="w-6 h-6 text-wh-teal flex-shrink-0 mt-0.5" data-id="element-190" />
                  <span className="text-gray-700" data-id="element-191">
                    Vector art conversion for screen printing
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-192">
                  <CheckCircle className="w-6 h-6 text-wh-teal flex-shrink-0 mt-0.5" data-id="element-193" />
                  <span className="text-gray-700" data-id="element-194">
                    File preparation and color matching
                  </span>
                </li>
              </ul>

              <div className="flex flex-col sm:flex-row gap-4" data-id="element-195">
                <Link to="/services/graphic-design" data-id="element-196">
                  <Button variant="primary" data-id="element-197">Graphic Design Services</Button>
                </Link>
                <Link to="/helpful-info/vector-art" data-id="element-198">
                  <Button variant="ghost" data-id="element-199">What Is Vector Art? →</Button>
                </Link>
              </div>
            </div>

            {/* Visual - Design Transformation Image */}
            <div className="relative h-64 lg:h-auto" data-id="element-200">
              <img src="https://cdn.magicpatterns.com/uploads/jcuD5Yfz86DSctSTgNXLm4/vector2.jpg" alt="Design transformation from sketch to finished artwork" className="w-full h-full object-cover" data-id="element-201" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}